module.exports = __webpack_public_path__ + "static/kitchen_night-8e8efc6c584941fccd5a340a34b9ee24.jpg";